import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom'
import { RootLayout } from './layout/RootLayout'
import { TodayScreen } from './screens/TodayScreen'
import { JourneyScreen } from './screens/JourneyScreen'
import { LibraryScreen } from './screens/LibraryScreen'
import { SettingsScreen } from './screens/SettingsScreen'
import { LessonScreen } from './screens/LessonScreen'
import { NotFoundScreen } from './screens/NotFoundScreen'

/**
 * The single route table for the app. Product areas map to top-level routes;
 * a lesson is a parameterized child. Everything renders inside {@link RootLayout},
 * which owns the persistent navigation and page frame. Exported so tests can
 * mount the same routes in a memory router.
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <Navigate to="/today" replace /> },
      { path: 'today', element: <TodayScreen /> },
      { path: 'journey', element: <JourneyScreen /> },
      { path: 'library', element: <LibraryScreen /> },
      { path: 'settings', element: <SettingsScreen /> },
      { path: 'lesson/:lessonId', element: <LessonScreen /> },
      { path: '*', element: <NotFoundScreen /> },
    ],
  },
]

export const router = createBrowserRouter(routes)
